module.exports = __webpack_public_path__ + "media/2.f0e5f398.wav";